import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsAzurepipelinesComponent } from './simple-icons-azurepipelines.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsAzurepipelinesComponent ],
    exports:      [ SimpleIconsAzurepipelinesComponent ],
    bootstrap:    []
})
export class SimpleIconsAzurepipelinesModule {}
